"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KEY = exports.default = void 0;
var _default = {
  TEST: 0,
  PRODUCTION: 1
};
exports.default = _default;
var KEY = 'privacyMode';
exports.KEY = KEY;